export default Object.freeze({
    debug: true,
    title: "時間別タスクリスト",
    actl:   "greenc-tasks-by-time",
    aaction: "gantt-list",
    add: "add-from-gantt-chart",
    edit: "edit-from-gantt-chart",
    delete: "delete-from-gantt-chart",
});